import { createReducer, on } from '@ngrx/store';
import {
  loadCurrentUser,
  loadCurrentUserFailure,
  loadCurrentUserSuccess,
  startImpersonation,
  startImpersonationFailure,
  startImpersonationSuccess,
  stopImpersonation,
  stopImpersonationFailure,
  stopImpersonationSuccess,
  switchCountry,
  switchCountryFailure,
  switchCountrySuccess,
  switchLanguage,
} from './current-user.actions';
import { CurrentUser, IUserProfile } from './current-user.model';

export const initialState: CurrentUser = {
  profile: {},
  loading: true,
  user: {} as IUserProfile,
  impersonating: false,
  impersonatedUserName: null,
};

export const currentUserReducer = createReducer(
  initialState,
  on(loadCurrentUser, (state) => ({
    ...state,
    loading: true,
  })),
  on(loadCurrentUserSuccess, (state, { currentUser }) => ({
    ...state,
    ...currentUser,
    loading: false,
  })),
  on(loadCurrentUserFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(switchCountry, (state) => ({ ...state, loading: true })),
  on(switchCountrySuccess, (state, { user }) => ({
    ...state,
    user: user,
    loading: false,
    error: null,
  })),
  on(switchCountryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(switchLanguage, (state, { language }) => ({
    ...state,
    user: {
      ...state.user,
      language: language,
    },
  })),
  on(startImpersonation, (state) => ({
    ...state,
    loading: true,
  })),
  on(startImpersonationSuccess, (state, { userName }) => ({
    ...state,
    impersonating: true,
    impersonatedUserName: userName,
    loading: false,
  })),
  on(startImpersonationFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(stopImpersonation, (state) => ({
    ...state,
    loading: true,
  })),
  on(stopImpersonationSuccess, (state) => ({
    ...state,
    impersonating: false,
    impersonatedUserName: null,
    loading: false,
  })),
  on(stopImpersonationFailure, (state) => ({
    ...state,
    loading: false,
  }))
);
